/**
 * FiasAIToggle - Toggle button for Fias AI popup.
 *
 * Uses the Fias logo and matches ModeToggleBar styling with
 * active/inactive states.
 */

interface FiasAIToggleProps {
  onClick: () => void;
  isActive?: boolean;
}

export function FiasAIToggle({ onClick, isActive = false }: FiasAIToggleProps) {
  return (
    <button
      onClick={onClick}
      className={`h-10 w-10 rounded-xl border-2 flex items-center justify-center transition-all ${
        isActive
          ? 'border-primary bg-background shadow-sm'
          : 'border-transparent bg-muted/50 opacity-90 hover:opacity-70'
      }`}
      title={isActive ? 'Close Fias AI' : 'Ask Fias AI'}
    >
      <img src="/Heptagen_Logo_1.png" alt="Fias AI" className="h-7 w-7" />
    </button>
  );
}
